import { ICustomColumnType } from 'shared/ui/VirtualTable';

import { DataType } from './DemandWidget.types';

import getDemandDataCell from './ui/getDemandDataCell';
import getDemandRecruiterCell from './ui/getDemandRecruiterCell';

export const DEFAULT_SORTING = 'demandStatusOrder,demandDesirableDate,desc';
export const PAGE_SIZE = 40;
export const THRESHOLD_VALUE = 5;
export const ROW_HEIGHT = 32;

export const columns: ICustomColumnType<DataType>[] = [
  {
    dataIndex: 'demandData',
    key: 'demandData',
    ellipsis: {
      showTitle: false,
    },
    sorter: false,
    width: '35%',
    minWidth: 250,
    render: getDemandDataCell,
  },
  {
    dataIndex: 'projectName',
    key: 'projectName',
    ellipsis: {
      showTitle: false,
    },
    sorter: false,
    width: '25%',
    minWidth: 150,
  },
  {
    dataIndex: 'demandRecruiter',
    key: 'demandRecruiter',
    ellipsis: {
      showTitle: false,
    },
    sorter: false,
    width: '20%',
    minWidth: 100,
    render: getDemandRecruiterCell,
  },
  {
    dataIndex: 'demandDesirableDate',
    key: 'demandDesirableDate',
    ellipsis: {
      showTitle: false,
    },
    sorter: false,
    width: '20%',
    minWidth: 100,
  },
];
